import { cast } from './Unsafe';
export const Unit = cast(undefined);
